export const feedbackConstants = {
    CREATE_SUCCESS: 'FEEDBACK_CREATE_SUCCESS',
    CREATE_FAILURE: 'FEEDBACK_CREATE_FAILURE',

    UPDATE_SUCCESS: 'FEEDBACK_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'FEEDBACK_UPDATE_FAILURE',

    DELETE_SUCCESS: 'FEEDBACK_DELETE_SUCCESS',
    DELETE_FAILURE: 'FEEDBACK_DELETE_FAILURE',

    GET_ONE_SUCCESS: 'FEEDBACK_GETONE_SUCCESS',
    GET_ONE_FAILURE: 'FEEDBACK_GETONE_FAILURE',

    GET_ALL_SUCCESS: 'FEEDBACK_GETALL_SUCCESS',
    GET_ALL_FAILURE: 'FEEDBACK_GETALL_FAILURE',
};